export default {
  calendar: {
    today: 'Today',
    tomorrow: 'Tomorrow',
    asap: 'ASAP',
  },
};
